module.exports = __webpack_public_path__ + "img/logo.28e8d4fa.jpg";